import React, { useId } from 'react';

export default function Input({
  label,
  error,
  id,
  className = '',
  ...props
}) {
  const generatedId = useId();
  const inputId = id || `input-${generatedId.replace(/:/g, '')}`;
  const errorId = error ? `${inputId}-error` : undefined;

  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        id={inputId}
        aria-invalid={!!error}
        aria-describedby={errorId}
        className={`
          w-full px-4 py-2 min-h-[44px] border rounded-lg
          focus:ring-2 focus:ring-primary-500 focus:border-transparent
          ${error ? 'border-danger-500' : 'border-gray-300'}
        `}
        {...props}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-danger-500" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
